import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css']
})
export class ConfirmModalComponent implements OnInit {

  @ViewChild('confirmModal', { static: false }) confirmModal: ModalDirective;

  readonly SCREEN_ID = 'O81';

  public message: string;

  public btnDelMsg: string;

  public observer: Observer<boolean>;

  public observable: Observable<boolean>;

  constructor() {
    this.observable = new Observable(observer => { this.observer = observer; });
  }

  ngOnInit() {
  }

  showConfirmModal(message: string, btnDelMsg: string): Observable<boolean> {

    this.message = message;
    this.btnDelMsg = btnDelMsg;
    this.confirmModal.show();

    return this.observable;
  }

  hideConfirmModal(confirmFlg: boolean): void {

    this.confirmModal.hide();
    this.observer.next(confirmFlg);
  }

}
